import React from 'react';
import { motion } from 'framer-motion';
import SafeIcon from '../common/SafeIcon';
import { services } from '../data/siteData';

function Services() {
  return (
    <section className="services-section panel-section" id="services">
      <div className="section-heading horizontal">
        <div>
          <span className="section-index">02 / Services</span>
          <h2>One platform.<br /><em>Endless</em> flexibility.</h2>
        </div>
        <p>Use it out of the box or shape every detail until the experience feels unmistakably yours.</p>
      </div>
      <div className="service-grid">
        {services.map((service, index) => (
          <motion.article
            className={index === 0 ? 'featured' : ''}
            key={service.title}
            whileHover={{ scale: 1.015 }}
          >
            <span className="service-icon"><SafeIcon icon={service.icon} /></span>
            <span className="service-count">0{index + 1}</span>
            <div>
              <h3>{service.title}</h3>
              <p>{service.text}</p>
            </div>
          </motion.article>
        ))}
      </div>
    </section>
  );
}

export default Services;